import React from 'react';
import { Button, Modal, ModalProps } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Form, Formik } from 'formik';
import { object, string } from 'yup';

import { FormGroupControl } from '@components/Base';
import { yupFile } from '@utils/yup';

import { DocumentCreatePayload } from './action';

export type DocumentFormValues = Pick<DocumentCreatePayload, 'name' | 'document'>;

const GROUP_PROPS = { className: 'mb-3' };

type FormFormProps = Pick<ModalProps, 'onHide'> & { title: string };

const FormForm = ({ onHide, title }: FormFormProps) => {
  const { t } = useTranslation();

  return (
    <Form>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroupControl
          asRow
          name="document"
          type="file"
          label={t('common:document')}
          required
          groupProps={GROUP_PROPS}
        />

        <FormGroupControl
          asRow
          name="name"
          label={t('user.name')}
          groupProps={GROUP_PROPS}
        />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          {t('confirmModal.cancel')}
        </Button>
        <Button type="submit" variant="primary">
          {t('common:save')}
        </Button>
      </Modal.Footer>
    </Form>
  );
}

type Props = ModalProps & {
  onSubmit: (values: DocumentFormValues) => void;
  title: string;
}

const DocumentFormModal = ({ onSubmit, title, ...props }: Props) => {
  const validationSchema = object({
    name: string().optional(),
    document: yupFile(true),
  });

  const initialValues: DocumentFormValues = {
    name: '',
    document: undefined,
  };

  return (
    <Modal {...props}>
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <FormForm onHide={props.onHide} title={title} />
      </Formik>
    </Modal>
  )
};

export { DocumentFormModal };
